import React, { memo } from 'react';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <header className="relative overflow-hidden" data-id="element-109">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-110" />
      <div className="absolute inset-0 bg-gradient-to-b from-familia-bg to-familia-section opacity-50 pointer-events-none" data-id="element-111" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-6 pb-10 text-center" data-id="element-112">
        <p className="text-familia-gold font-semibold text-[10px] sm:text-xs uppercase tracking-[0.25em] mb-2" data-id="element-113">
          Vitalidad 360 · Master Kit Adultos Mayores
        </p>

        <h1 className="font-display sm:text-4xl md:text-5xl font-bold mb-4 text-[24px]" data-id="element-114">
          ¿Cuánto más vas a ver cómo se apaga de a poco? Devolvele la alegría,
          la memoria y el movimiento a tu ser querido en solo 15 minutos al día.
        </h1>

        {/* Mockup directly below the title */}
        <div className="relative max-w-[320px] sm:max-w-[460px] md:max-w-[560px] mx-auto mb-5" style={{
        aspectRatio: '3 / 2'
      }} data-id="element-115">
          <div aria-hidden="true" className="absolute inset-0 bg-familia-cyan/20 rounded-full hidden md:block" style={{
          filter: 'blur(70px)'
        }} data-id="element-116" />
          <img src="https://cdn.magicpatterns.com/uploads/nQuCFAXjN5rWqH1CYg6bzM/ChatGPT_Image_28_may_2026__09_10_42_p.m.-removebg-preview.png" alt="Vitalidad 360 Master Kit — Kinesiólogo presentando el sistema" width="560" height="373" loading="eager" className="relative z-10 w-full h-full object-contain" style={{
          filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.45))'
        }} data-id="element-117" />
        </div>

        <h2 className="text-familia-gray sm:text-sm max-w-xl mx-auto mb-4 text-[11px] leading-relaxed" data-id="element-118">
          El sistema más completo de 2026 para acompañar adultos mayores en
          casa. Más de 150 actividades imprimibles, guías de movilidad,
          registros de salud y protocolos de cuidado experto. Todo listo para
          usar desde hoy.
        </h2>

        <div className="mb-4 flex justify-center" data-id="element-119">
          <span className="bg-familia-card border border-familia-cyan/25 px-4 py-2 rounded-full text-[10px] sm:text-xs font-bold flex flex-col sm:flex-row items-center gap-2 text-white text-center" data-id="element-120">
            <span data-id="element-121">📄 Kit digital imprimible</span>
            <span className="hidden sm:inline" data-id="element-122">·</span>
            <span data-id="element-123">⚡ Acceso inmediato por email</span>
          </span>
        </div>

        <CTAButton href="#precio-lanzamiento" className="w-full sm:w-auto text-base px-10 py-3.5 mb-3" data-id="element-124">
          SÍ, QUIERO EL KIT COMPLETO AHORA
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 text-[9px] sm:text-[11px] text-familia-gray" data-id="element-125">
          <span className="flex items-center gap-1.5" data-id="element-126">
            🛡️ Garantía de satisfacción de 30 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-127">
            🔒 Pago 100% seguro con Mercado Pago
          </span>
          <span className="flex items-center gap-1.5" data-id="element-128">
            💳 Tarjeta, débito y dinero en cuenta
          </span>
        </div>
      </div>
    </header>;
};